<template>
  <div id="app" :js-view="$route.name">
    <div class="app__wrapper">
      <Header />


      <transition
        @enter="enter"
        @leave="leave"
        :css="false"
        mode="out-in"
        name="total"
      >
        <main js-pagecontainer>
          <Muselet />

            <transition @enter="enter" @leave="leave" :css="false" mode="out-in" name="routerView">
              <router-view
                :key="path"
                v-if="!loading"
              ></router-view>
            </transition>

            <div class="event__btns"
              :class="$route.name !== 'event' ? 'hide': false"
              v-if="!loading"
            >
              <Cta
                v-for="(btn, index) in buttons"
                :key="index"
                :btn="btn"
                :class="`btn-js btn--${btn.symbol}`"
                js-refPage="event"
                @click.native="avoidInteractions"
              />
            </div>

          <Artwork />
        </main>
      </transition>

      <Footer />

      <BgNoise />

      <Pointer v-if="!isDevice()" />

      <Whistle />

      <CircleSwitch />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { qs, isDevice, isMobile } from '@/scripts/utils';

import debounce from 'lodash/debounce';
import FontFaceObserver from 'fontfaceobserver';

import Header from '@/components/Header';
import Muselet from '@/components/Muselet';
import Artwork from '@/components/Artwork';
import Cta from '@/components/utils/Cta';
import Footer from '@/components/Footer';
import BgNoise from '@/components/BgNoise';
import Pointer from '@/components/Pointer';
import CircleSwitch from '@/components/CircleSwitch';
import Whistle from '@/components/Whistle';

import transitions from '@/scripts/transitions';
import animations from '@/scripts/animations';


export default {
  name: 'app',

  components: {
    Header,
    Muselet,
    Artwork,
    Cta,
    Footer,
    BgNoise,
    Pointer,
    CircleSwitch,
    Whistle,
  },

  data() {
    return {
      windowW: window.innerWidth,
      prevPage: 'loader',
      isMobile,

      loading: true,
      setted: false,
      isDevice,

      buttons: [
        {
          symbol: 'previous',
          link: '/',
          it: {
            textPrimary: false,
            textAlt: false,
          },
          en: {
            textPrimary: false,
            textAlt: false,
          },
        }, {
          symbol: 'next',
          link: '/',
          it: {
            textPrimary: false,
            textAlt: false,
          },
          en: {
            textPrimary: false,
            textAlt: false,
          },
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      currentEvent: 'getEventName',

      eventsList: 'getEventsList',

      lang: 'getLang',
    }),

    path() {
      const path = this.currentEvent === null ? 'home' : this.currentEvent;
      return path;
    },
  },

  watch: {
    currentEvent(newVal) {
      if (newVal !== '' && !this.setted) this.updateBtnSlider();
    },
  },

  created() {
    window.addEventListener('resize', debounce(() => this.resize(), 200));
  },

  mounted() {
    const font = new FontFaceObserver('Playfair Display', {
      weight: 700,
    });

    font.load(null, 5000).then(() => {
      if (!this.isMobile()) {
        animations.get('loader')(this.$el, this.stopLoading);
      } else {
        this.stopLoading();
      }
    });

    this.$eventHub.$on('windowResized', () => {
      if (this.windowW >= 1320 && window.innerWidth < 1320) this.$router.go();
      if (this.windowW >= 1024 && window.innerWidth < 1024) this.$router.go(); // eslint-disable-line
      if (this.windowW >= 768 && window.innerWidth < 768) this.$router.go(); // eslint-disable-line
      if (this.windowW >= 480 && window.innerWidth < 480) this.$router.go(); // eslint-disable-line

      if (this.windowW <= 1024 && window.innerWidth > 1024) this.$router.go(); // eslint-disable-line
      if (this.windowW <= 768 && window.innerWidth > 768) this.$router.go(); // eslint-disable-line
      if (this.windowW <= 480 && window.innerWidth > 480) this.$router.go(); // eslint-disable-line
    });
  },

  methods: {
    resize() {
      this.$eventHub.$emit('windowResized');
    },

    enter(el, done) {
      const page = el.getAttribute('js-page');

      const callback = () => {
        done();
        this.$store.commit('ALL_LOADED', true);
      };

      if (page === 'index') {
        transitions.get(page)(el, 'in', this.prevPage, callback);
      } else {
        transitions.get(page)(el, 'in', this.prevPage, page, callback);
      }
    },

    leave(el, done) {
      const page = el.getAttribute('js-page');
      const next = this.$route.name;

      const callback = () => {
        done();
        this.$store.commit('ALL_LOADED', true);
      };

      if (page === 'index') {
        transitions.get(page)(el, 'out', this.prevPage, callback);
      } else {
        transitions.get(page)(el, 'out', this.prevPage, next, callback);
      }

      this.prevPage = page;
    },

    stopLoading() {
      this.loading = false;
    },

    updateBtnSlider() {
      this.setted = true;
      let currentIndex;

      this.eventsList[this.lang].forEach((event) => {
        if (event.link === this.currentEvent) currentIndex = event.order;
      });

      // const current = this.events[currentIndex];
      const prev = currentIndex === 0 ? this.eventsList[this.lang].length - 1 : currentIndex - 1; // eslint-disable-line
      const next = currentIndex === this.eventsList[this.lang].length - 1 ? 0 : currentIndex + 1; // eslint-disable-line
      const eventInLang = this.eventsList[this.lang];

      if (this.buttons[0] === undefined || this.buttons[1] === undefined) {
        this.setted = false;
        return;
      }

      this.buttons[0].link = `/${this.lang}/${eventInLang[prev].link}`;
      this.buttons[1].link = `/${this.lang}/${eventInLang[next].link}`;

      this.setted = false;
    },

    avoidInteractions() {
      qs('.event__btns').classList.add('avoid');
    },
  },
};
</script>

<style lang="scss">
@import 'application';

body {
  cursor: url('/static/vector/cursor.png'), default !important;
}

a:hover {
  cursor: url('/static/vector/cursor-pointer.png'), default !important;
}

#app {
  .app__wrapper {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    height: 100%;

    @include mq(sm) {
      overflow: hidden;
    }
  }
}

main {
  position: relative;
  max-width: 100%;
  margin: 0 auto;
  // height: calc(100vh - 77px);
  height: 100vh;

  padding: 0px 10px;

  @extend %flex;
  align-items: flex-start;

  @include mq(xxs) {
    padding: 0px 30px;
  }

  @include mq(sm) {
    align-items: center;
  }

  @include mq(md) {
    align-items: center;
  }

  @include mq(lg) {
    max-width: 1240px;
  }
}

.event__btns {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  padding: 20px 30px 10px;
  -webkit-mask: linear-gradient(to bottom,rgba(0,0,0,.1) 0,rgba(0,0,0,1) 20px,#000 100px);
  background: $color-light;

  @extend %flex;
  justify-content: space-between;

  &.hide, &.avoid {
    pointer-events: none;
  }

  @include mq(sm) {
    position: absolute;
    top: 50%;
    left: auto;
    right: 0px;
    bottom: auto;
    width: auto;
    justify-content: flex-start;
    padding: 0;
    flex-direction: column-reverse;

    background: none;
    -webkit-mask: none;

    transform: translate3d(0, 80px, 0);
  }

  @include mq(lg) {
    right: -20px;
  }

  .btn {
    &--previous {
      @include mq(sm) {
        position: relative;
        margin-top: -15px;
        .btn {
          padding-top: 0;
          &__img {
            top: 14px;
            position: relative;
          }
        }
      }
    }
    &--next {
      @include mq(sm) {
        position: relative;
        margin-top: 20px;
        .btn {
          padding-bottom: 0;
          &__img {
            top: -6px;
            position: relative;
          }
        }
      }
    }
  }
}

.marquee3k__wrapper {
  will-change: tranform;
  backface-visibility: hidden;
}

.anim__wrapper {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue